import { render, staticRenderFns } from "./rfq-tab-basic.vue?vue&type=template&id=7cf4c8c6"
import script from "./rfq-tab-basic.vue?vue&type=script&lang=js"
export * from "./rfq-tab-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports